var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 2.73372V4.20039C13.7333 4.73372 13.4 5.40039 13.0667 5.73372L10.2 8.26706C9.80001 8.60039 9.53334 9.26706 9.53334 9.80039V12.6671C9.53334 13.0671 9.26667 13.6004 8.93334 13.8004L8.00001 14.4004C7.13334 14.9337 5.93334 14.3337 5.93334 13.2671V9.73372C5.93334 9.26706 5.66667 8.66706 5.40001 8.33372L5.08667 8.00706C4.88001 7.78706 4.84001 7.45372 5.00667 7.19372L8.42001 1.71372C8.54001 1.52039 8.75334 1.40039 8.98667 1.40039H12.4C13.1333 1.40039 13.7333 2.00039 13.7333 2.73372Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 2.42039L4.53333 6.21372C4.30666 6.58039 3.78666 6.63372 3.48666 6.32039L2.86666 5.66706C2.53333 5.33372 2.26666 4.73372 2.26666 4.33372V2.80039C2.26666 2.00039 2.86666 1.40039 3.6 1.40039H6.33333C6.85333 1.40039 7.17333 1.97372 6.9 2.42039Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7b04cedd9e4309dbb33ad8c87be32a06.svg";
export { ForwardRef as ReactComponent };